import { CHECKOUT_REDIRECT_LOCK_KEY, CheckoutRedirectService } from '@libs/renegkit';
import { useRkCheckoutFlowExperiment } from '@libs/renegkit/experiments/RkCheckoutFlow';
import { useNavigate } from 'react-router-dom';

import { FormattedDebt } from '@common/contexts/DebtsContext/types';

export const CONSULTING_DEBT_SEARCH_PARAM = 'consulting_debt';
export const SINGLE_DEBT_SEARCH_PARAM = 'single_debt';

export const DEBT_PARAM_TYPES = {
  SINGLE: 'single',
} as const;

type DebtParamType = (typeof DEBT_PARAM_TYPES)[keyof typeof DEBT_PARAM_TYPES] | null;

export const ExpressCheckout = () => {
  const navigate = useNavigate();
  const { isRenegkitVariant } = useRkCheckoutFlowExperiment();

  function checkExpressParams(): DebtParamType {
    const params = new URLSearchParams(window.location.search);

    if (params.has(SINGLE_DEBT_SEARCH_PARAM)) {
      return DEBT_PARAM_TYPES.SINGLE;
    }

    return null;
  }

  function actionExpressCheckout(debt: FormattedDebt, type: 'single') {
    const partner = debt?.partner;

    const redirectUrl = CheckoutRedirectService.getCheckoutRedirectUrl({
      creditorSlug: partner?.partnerIdentifier,
      systemSlug: partner?.identifier,
      debtId: debt?.id,
    });

    if (!redirectUrl) return;

    const paramMap = {
      [DEBT_PARAM_TYPES.SINGLE]: SINGLE_DEBT_SEARCH_PARAM,
    };

    if (isRenegkitVariant) {
      const creditorSlug = partner?.partnerIdentifier;
      const params = new URLSearchParams();

      if (partner?.identifier) params.set('systemSlug', partner.identifier);
      if (debt?.id) params.set('offerId', String(debt.id));
      params.set(paramMap[type], 'true');

      sessionStorage.setItem(CHECKOUT_REDIRECT_LOCK_KEY, 'true');

      const isDesenrola = !!debt?.properties?.some(
        (prop: any) => prop.key === 'IS_DESENROLA' && prop.booleanValue === true,
      );

      navigate(`/checkout/oferta/${creditorSlug}?${params.toString()}`, {
        state: { source: 'express_checkout', isDesenrola },
      });
      return;
    }

    const checkoutParams = `${paramMap[type]}=true`;
    const linkToExpress = `${redirectUrl}&${checkoutParams}`;

    sessionStorage.setItem(CHECKOUT_REDIRECT_LOCK_KEY, 'true');
    navigate(linkToExpress, { state: { source: 'express_checkout' } });
  }

  return {
    checkExpressParams,
    actionExpressCheckout,
  };
};
